'use client';

import { usePageTracking } from 'hooks/tracking';

import { useAuthGateStore } from 'stores/authGateStore';

import { AuthGateSkeleton } from 'components/shared/layout/auth/AuthGateSkeleton';
import { AuthProtection } from 'components/shared/layout/auth/AuthProtection';

// usePageTracking reads useParams(), which — unlike useSearchParams() — does not opt
// this subtree out of static prerendering, so the form still ships in the HTML.
export const LoginView = () => {
  usePageTracking('Login');
  const authStatus = useAuthGateStore(state => state.status);

  if (
    authStatus === 'redirecting'
  ) {
    return <AuthGateSkeleton />;
  }

  return <AuthProtection />;
};
